import React from 'react';
import { Agent } from '../../types';
import { useSessionStore, runtimeFromAgent } from '../../stores/sessionStore';
import { ChatDialog } from './ChatDialog';
interface Props {
  agent: Agent;
  open: boolean;
  onClose: () => void;
  isTest?: boolean;
  /** When provided, bind to an existing session (history restore) instead of creating a new one. */
  existingSessionId?: string;
}
export function AgentChatDialog({
  agent,
  open,
  onClose,
  isTest,
  existingSessionId
}: Props) {
  const startSession = useSessionStore(s => s.startSession);
  const runtime = runtimeFromAgent(agent);
  return <ChatDialog runtime={runtime} open={open} onClose={onClose} isTest={isTest} existingSessionId={existingSessionId} createSession={() => startSession(agent, agent.defaultModelId, isTest)} data-id="element-36" />;
}